// @mui
import { GlobalStyles } from "@mui/material"
import { useTheme } from "@mui/material/styles"

export default function AppGlobalStyles() {
  const theme = useTheme()

  return (
    <GlobalStyles
      styles={{
        "*": {
          margin: 0,
          padding: 0,
          boxSizing: "border-box"
        },
        html: {
          width: "100%",
          height: "100%",
          overflow: "hidden",
          WebkitOverflowScrolling: "touch",
          backgroundColor: "transparent!important"
        },
        body: {
          width: "100%",
          height: "100%",
          overflow: "hidden",
          fontFamily: "Inter Variable, sans-serif",
          backgroundColor: "transparent!important"
        },
        "div#app": {
          width: "100%",
          height: "100%",
          overflow: "hidden",
          backgroundColor: "transparent!important"
        },
        a: {
          textDecoration: "none",
          color: "inherit"
        },
        input: {
          "&[type=number]": {
            MozAppearance: "textfield",
            "&::-webkit-outer-spin-button": {
              margin: 0,
              WebkitAppearance: "none"
            },
            "&::-webkit-inner-spin-button": {
              margin: 0,
              WebkitAppearance: "none"
            }
          }
        },
        textarea: {
          "&::-webkit-input-placeholder": {
            color: theme.palette.text.disabled
          },
          "&::-moz-placeholder": {
            opacity: 1,
            color: theme.palette.text.disabled
          },
          "&:-ms-input-placeholder": {
            color: theme.palette.text.disabled
          },
          "&::placeholder": {
            color: theme.palette.text.disabled
          }
        },
        img: { display: "block", maxWidth: "100%" },
        ".ProseMirror ol, .ProseMirror ul, .lm-comment-list ol, .lm-comment-list ul": {
          marginLeft: theme.spacing(3)
        },
        ".max-two-lines": {
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        ".max-one-line": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }}
    />
  )
}
